import { Controller, useForm } from "react-hook-form";
import classes from "../../../../../../components/Popover/popover.module.scss";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";
import { createPayment, selectExpense, setNewPaymentPopover } from "../main.slice";
import { toast } from "react-toastify";
import { useAppDispatch } from "hooks/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classesExpense from "../../../styles/NewExpensePopover.module.scss";
import { ICreatePaymentRequestParams } from "Dashboard/scenes/Expenses/domain/ICreatePaymentRequestParams";
import { useSelector } from "react-redux";

const NewPaymentPopover = () => {

  const dispatch = useAppDispatch();
  const expenseItem = useSelector(selectExpense);

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
  } = useForm<ICreatePaymentRequestParams>();

  const onSubmit = async (data: ICreatePaymentRequestParams) => {
    try {
      await dispatch(createPayment({ expenseId: expenseItem.expenseId, data: data }));
      close();
      toast.success("Isplata je uspesno dodata.");
    } catch (err) {
      console.error(err);
    }
  };

  const close = () => {
    dispatch(setNewPaymentPopover({ isOpen: false }));
    reset();
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`${classesExpense.newExpensePopover} ${classes.basicPopover}`}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum</label>
          <Controller
            control={control}
            name="date"
            defaultValue={undefined}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  className={`${classes.dateItem} ${classes.itemBorder} 
                    ${errors.date ? classes.itemError : ""}`}
                  onChange={(date) => {
                    onChange(date ? FormatDateIso(date) : undefined);
                  }}
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>iznos</label>
          <input type="number" className={`${classes.itemBorder}
            ${errors.amount ? classes.itemError : ""}`}
            {...register("amount", { required: true })}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon icon={faLongArrowAltDown} className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewPaymentPopover;
